//certifications


export const GetAllEvaluationTypes = () => {
  return $.get('Evaluation/GetAllEvaluationTypes?IsActive=true')
}
export const GetPerformanceLevels = () => {
  return $.get('Evaluation/GetAllPerformanceLevels?IsActive=true')
}
export const GetEvaluation = (id) => {
  return $.get('Personnel/GetEvaluationById?Id=' + id)
}


export const AddEvaluation = (model) => {
  return $.post('Personnel/AddEvaluation', model)
}
export const DeleteEvaluation = (KudosId) => {
  return $.post('Personnel/DeleteEvaluation?EvaluationId=' + KudosId)
}
export const UpdateEvaluation = (model) => {
  return $.post('Personnel/UpdateEvaluation', model)
}
export const GetCommendableActionTypes = () => {
  return $.get('Personnel/GetCommendableActionTypes')
}


export const GetAllusers= () => {
  return $.get('api/Training/GetAllUsers')
}





// WEBPACK FOOTER //
// ./src/components/Evaluation/Evaluation.services.js